import { useQuery } from '@tanstack/react-query';
import { serviceChargeService } from '@/services/compensation/serviceChargeService';
import { serviceChargeKeys } from './queryKeys';

export const useServiceChargePeriods = () => {
  return useQuery({
    queryKey: serviceChargeKeys.periods(),
    queryFn: () => serviceChargeService.getPeriods(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};

export const useServiceChargePeriod = (periodId: string, enabled = true) => {
  return useQuery({
    queryKey: serviceChargeKeys.periodWithWeights(periodId),
    queryFn: () => serviceChargeService.getPeriodWithWeights(periodId),
    enabled: enabled && !!periodId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};

export const useServiceChargeAssignments = (periodId: string, enabled = true) => {
  return useQuery({
    queryKey: serviceChargeKeys.assignments(periodId),
    queryFn: () => serviceChargeService.getEmployeeAssignments(periodId),
    enabled: enabled && !!periodId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
